import { Typography } from '@mui/material';

import FormField from 'further-ui/components/FormField';
import { Column } from 'further-ui/components/Layout';

import api from 'lib/trpcClient';
import CoolOffResult from './CoolOffResult';
import InvestorClassificationResult from './InvestorClassificationResult';

type Props = {
  vehicleId: string;
  vehicleApplicationId: string;
  investorId: string;
};

const InvestorClassificationDetails: React.FC<Props> = ({
  vehicleId,
  vehicleApplicationId,
  investorId,
}) => {
  const [classificationResult] =
    api.investorClassification.getClassificationResult.useSuspenseQuery({
      vehicleId,
      vehicleApplicationId,
    });
  const [onboardingSettings] = api.vehicle.onboardingSettings.useSuspenseQuery({
    vehicleId,
  });

  return (
    <Column fullWidth spacing="md">
      <InvestorClassificationResult
        classificationResult={classificationResult}
        onboardingSettings={onboardingSettings}
      />

      <FormField label="24-hour cool off" spacing="xxs">
        <Typography variant="body2" color="grey.600">
          {classificationResult ? (
            <CoolOffResult
              investorId={investorId}
              vehicleId={vehicleId}
              useCoolOff={
                classificationResult.investorClassificationType.requiresCoolOff
              }
            />
          ) : (
            '--'
          )}
        </Typography>
      </FormField>
    </Column>
  );
};

export default InvestorClassificationDetails;
